// order of entries must not be changed
export const KEYS_IN_ORDER = [
    'category',
    'carlineId',
    'salesGroupId',
    'trimName',
    'modelId',
    'modelYear',
    'modelVersion',
    'exteriorId',
    'interiorId'
    // 'options' don't need to be checked as no options is a valid configuration
];
export const URL_KEYS = [...KEYS_IN_ORDER, 'options'];
export const KEYS_PLUS_BUILDABILITY = [
    ...KEYS_IN_ORDER,
    'buildabilityStatus'
];
export const LOCKED_OR_UNSET = '+';
export const ARRAY_VALUE_SEPERATOR = '-';
